function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import ApplicationSerializer from '@square/dashboard-data/serializers/application';
export default class MerchantSubunitBasic extends ApplicationSerializer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "primaryKey", 'token');
    _defineProperty(this, "collectionKey", 'entities');
    _defineProperty(this, "rootKey", 'entity');
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // if the response is nested inside the collection key or root-key, use that
    const newPayload = payload[this.collectionKey] || payload[this.rootKey] || payload;
    return super.normalizeResponse(store, primaryModelClass, newPayload, id, requestType);
  }
  pushPayload(store, payload) {
    const modelName = this.toString().split(':')[1];
    const modelClass = store.modelFor(modelName);
    const normalized = this.normalizeSingleResponse(store, modelClass, payload);

    // pushPayload does not return the record.
    // If the record is needed after this function, use peekRecord.
    store.push(normalized);
  }
}